export default "__VITE_ASSET__Bw9d0P5i__"